import React from 'react';
import { useNavigate } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Box, Typography, Button } from '@mui/material';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { DeviceOrientationIcon } from '@icons/DeviceOrientationIcon';
import DashboardAppHeader from '../DashboardAppHeader';
import { useStyles } from './styles';
import { IOrientationOverlay } from './interfaces';

import ROUTES from '@constants/routes';

const OrientationOverlay = ({
  isButton,
  onClick,
  t: translate,
}: IOrientationOverlay) => {
  const classes = useStyles();

  const { currentEventId } = useMytaverseEvent();
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(ROUTES.DEVICES_TEST(currentEventId));
  };

  return (
    <Box sx={classes.root(isButton)}>
      <DashboardAppHeader isAuthorized onBackClick={handleClick} />
      <Box sx={classes.container}>
        <Box sx={classes.content}>
          <DeviceOrientationIcon sx={classes.icon} />
          <Typography sx={classes.title}>
            {translate('orientationScreen.title')}
          </Typography>
          <Typography sx={classes.description}>
            {translate('orientationScreen.text')}
            <Typography component="span" sx={classes.boldText}>
              {translate('orientationScreen.textBold')}
            </Typography>
          </Typography>
        </Box>
        <Button onClick={onClick} sx={classes.button(isButton)}>
          {translate('continue')}
        </Button>
      </Box>
    </Box>
  );
};

export default withTranslation()(OrientationOverlay);
